import { useState } from "react";

interface Props {
  images: string[];
  name: string;
}

export default function ScreenshotGallery({ images, name }: Props) {
  const [active, setActive] = useState(0);
  if (images.length === 0) return null;

  const go = (dir: number) => {
    setActive((prev) => (prev + dir + images.length) % images.length);
  };

  return (
    <section>
      <h2 className="mb-3 flex items-center gap-2 font-heading text-lg font-bold text-foreground-900">
        <i className="ri-image-2-line text-primary-600" />
        软件截图
      </h2>
      <div className="relative overflow-hidden rounded-lg border border-background-200 bg-secondary-950">
        <img
          key={active}
          src={images[active]}
          alt={`${name}软件界面截图 ${active + 1}`}
          title={`${name} 界面预览`}
          className="h-[240px] w-full animate-fade-up object-cover object-top md:h-[420px]"
        />
        <button
          type="button"
          onClick={() => go(-1)}
          aria-label="上一张截图"
          className="absolute left-3 top-1/2 -translate-y-1/2 flex h-9 w-9 items-center justify-center rounded-full bg-secondary-900/80 text-background-50 backdrop-blur transition-colors hover:bg-primary-500 hover:text-foreground-950 cursor-pointer"
        >
          <i className="ri-arrow-left-s-line text-xl" />
        </button>
        <button
          type="button"
          onClick={() => go(1)}
          aria-label="下一张截图"
          className="absolute right-3 top-1/2 -translate-y-1/2 flex h-9 w-9 items-center justify-center rounded-full bg-secondary-900/80 text-background-50 backdrop-blur transition-colors hover:bg-primary-500 hover:text-foreground-950 cursor-pointer"
        >
          <i className="ri-arrow-right-s-line text-xl" />
        </button>
        <span className="absolute bottom-3 right-3 chip bg-secondary-900/80 text-background-100 backdrop-blur-sm">
          {active + 1} / {images.length}
        </span>
      </div>
      <div className="mt-3 flex gap-3 overflow-x-auto no-scrollbar pb-1">
        {images.map((img, idx) => (
          <button
            key={img}
            type="button"
            onClick={() => setActive(idx)}
            aria-label={`查看第 ${idx + 1} 张截图`}
            className={`relative h-16 w-24 shrink-0 overflow-hidden rounded-md border-2 transition-colors cursor-pointer ${
              idx === active ? "border-primary-500" : "border-transparent opacity-70 hover:opacity-100"
            }`}
          >
            <img
              src={img}
              alt={`${name}界面截图缩略图 ${idx + 1}`}
              className="h-full w-full object-cover object-top"
            />
          </button>
        ))}
      </div>
    </section>
  );
}